/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceRespVo } from './ServiceRespVo';
import {
    ServiceRespVoFromJSON,
    ServiceRespVoFromJSONTyped,
    ServiceRespVoToJSON,
    ServiceRespVoToJSONTyped,
} from './ServiceRespVo';

/**
 * 
 * @export
 * @interface DeliveryCalculationAdditionalServiceRespVo
 */
export interface DeliveryCalculationAdditionalServiceRespVo {
    /**
     * 仓库ID
     * @type {number}
     * @memberof DeliveryCalculationAdditionalServiceRespVo
     */
    warehouseId?: number;
    /**
     * 仓库名称
     * @type {string}
     * @memberof DeliveryCalculationAdditionalServiceRespVo
     */
    warehouseName?: string;
    /**
     * 仓库对应的附加服务
     * 附加服务列表
     * @type {Array<ServiceRespVo>}
     * @memberof DeliveryCalculationAdditionalServiceRespVo
     */
    services?: Array<ServiceRespVo>;
}

/**
 * Check if a given object implements the DeliveryCalculationAdditionalServiceRespVo interface.
 */
export function instanceOfDeliveryCalculationAdditionalServiceRespVo(value: object): value is DeliveryCalculationAdditionalServiceRespVo {
    return true;
}

export function DeliveryCalculationAdditionalServiceRespVoFromJSON(json: any): DeliveryCalculationAdditionalServiceRespVo {
    return DeliveryCalculationAdditionalServiceRespVoFromJSONTyped(json, false);
}

export function DeliveryCalculationAdditionalServiceRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryCalculationAdditionalServiceRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(ServiceRespVoFromJSON)),
    };
}

export function DeliveryCalculationAdditionalServiceRespVoToJSON(json: any): DeliveryCalculationAdditionalServiceRespVo {
    return DeliveryCalculationAdditionalServiceRespVoToJSONTyped(json, false);
}

export function DeliveryCalculationAdditionalServiceRespVoToJSONTyped(value?: DeliveryCalculationAdditionalServiceRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(ServiceRespVoToJSON)),
    };
}

